module.exports = __webpack_public_path__ + "static/media/emailicon.fdcbd111.svg";